export default __webpack_public_path__ + "images/10e056070c83d58a24766f37483cfafe-fall_seasonal_tablet.webp";